<template>
  <div>
    <div class="page-content">
      <div class="container-fluid background">
        <div class="row">
          <img src="~@/assets/images/brick-wall.jpg" alt="Brick wall" class="col-12 p-0">
        </div>
      </div>
      <div class="container content">
        <div class="row">
          <div class="col-12">
            <h1 class="page-header">
              Our Services
              <hr />
            </h1>
          </div>
          <div class="col-lg-6 page-content-inner">
            <h2>New Builds<hr /></h2>
            <p>
              Our wealth of knowledge and experience enables us to build you your dream home from scratch. Our professional approach will ensure your property is built to comply with all building regulations and is built to the exact specification you require and to the highest standard possible.
            </p>

            <h2>Extensions<hr /></h2>
            <p>
              If you are looking to create more space and add some value to your property by extending it, we have you covered. Whether it's a front or rear porch, garage/workshop or a single/double storey extension, we can fulfil all your needs and requirements.
            </p>

            <h2>Garden Walls<hr /></h2>
            <p>
              From boundary walls to retaining walls, feature walls to raised flower beds, we're able to build them all. If you require assistance with designing it, or would like some friendly advice, we're of course more than happy to help with that too.
            </p>

            <h2>Footings<hr /></h2>
            <p>
              Footings/foundations are one of, if not the most important part of the project. At Ashfield Brickwork, we will excavate and pour the concrete to ensure the foundations are laid to the correct standard and ensure your project is able to be built safely and securely.
            </p>
          </div>
          <div class="col-lg-6 page-content-inner">
            <h2>Patios<hr /></h2>
            <p>
              Are you looking to give your garden a fresh look, or create some outside space for those summer evenings? A patio is a fantastic way to do so. Whether you're looking to use porcelain, natural stone or concrete slabs, we have experience using them all. We will ensure that we use all the correct materials to make your new patio last.
            </p>

            <h2>Groundworks<hr /></h2>
            <p>
              We're able to carry out work in the ground, as well as above it. Whether it's brick pavers, concreting, block and beam floors & oversites or drainage and soakaways, we're able to carry out the works efficiently and effectively.
            </p>

            <h2>Repairs & Alterations<hr /></h2>
            <p>
              If you would like to make some alterations to your home by making some internal or external structural changes, we are able to carry out works including internal & external wall alterations, RSJ installation and window & door alterations to modify your home and get it looking exactly how you imagined. Should you need something repaired, i.e. a wall that's fallen down or cracked, we're able to help with this too.
            </p>
          </div>
          <div class="col-lg-6 mt-5 mt-lg-0">
            <img class="about-us-img" src="~@/assets/images/portfolio/img_0760.jpg" alt="Brick wall project image" />
          </div>
        </div>
      </div>
    </div>
    <div id="cta-banner" class="cta-banner">
      <div class="container">
        <div class="row">
          <div class="col-lg-12 col-xl-3 cta-banner-wrapper">
            <h2 class="cta-banner-title">
              Get In Touch
            </h2>
          </div>
          <div class="col-lg-8 col-xl-6 cta-banner-wrapper">
            <p class="cta-banner-content">
              For your free no obligation quote, get in touch today
            </p>
          </div>
          <div class="col-lg-4 col-xl-3 cta-banner-wrapper">
            <router-link to="/contact-us/" class="mt-4 mt-lg-0 btn cta-banner-btn">
              Contact Us
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'our-services'
}
</script>

<style lang="scss" scoped>
@import "../../assets/styles/variables/colors";
@import "../../assets/styles/variables/breakpoints";

/****************************
    BANNER
*****************************/
.background {
  margin-top: -64px;
  width: 100%;
  height: 430px;
  border-bottom: 3px solid $primary;

  @media screen and (max-width: $md-breakpoint) {
    height: 300px;
  }

  .row {
    height: 100%;
  }

  .row img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}

/****************************
    CONTENT
*****************************/
.content {
  margin-top: 64px;
  h2 {
    font-size: 28px;
    @media (max-width: $md-breakpoint) {
      font-size: 22px !important;
      }
  }
}

.page-content-inner hr {
  margin-bottom: 10px;
  margin-top: 10px;
  width: 50px;
}

/****************************
    ABOUT US
*****************************/
.about-us {
  &-img {
    border-radius: 0.3rem;
    border: 3px solid $primary;
    width: 100%;
    height: 100%;
    object-fit: cover;
    vertical-align: baseline;
  }
}

/****************************
    GET IN TOUCH CTA
*****************************/
.cta-banner {
  background-color: $primary;
  padding: 30px 0;

  &-wrapper {
    display: flex;
    align-items: center;

    &:last-child {
      justify-content: flex-end;

      @media (max-width: $lg-breakpoint) {
        justify-content: center;
      }

      @media (max-width: $md-breakpoint) {
        justify-content: flex-start;
      }
    }
  }

  &-title {
    font-size: 40px;
    font-weight: 500;
    color: $white;
  }

  &-content {
    margin: 0;
    font-size: 18px;
    color: $white;
  }

  &-btn {
    background-color: $primary-dark;

    &:hover {
      background-color: $white;
      color: $primary;
    }
  }
}</style>



// WEBPACK FOOTER //
// src/components/pages/OurServices.vue